import { useCheckCompletedStakingsMutation } from "store/apis/stakingAPI"
import { useModal } from "context/ModalsContext"

export const useCheckStakingCompleted = () => {
  const { openModal } = useModal()

  const [checkCompletedStakings] = useCheckCompletedStakingsMutation()

  const checkStakingCompleted = async () => {
    try {
      const checkedStakingData = await checkCompletedStakings().unwrap()

      if (checkedStakingData.hasCompletedStakings) {
        openModal({
          type: "stakingFinished",
          params: {
            income: checkedStakingData.income,
            stakings: checkedStakingData.stakings
          }
        })
      }
    } catch (err) {
      console.error("Staking check failed:", err)
    }
  }

  return checkStakingCompleted
}
